import { GET_ALL_CUSTOMERS, GET_ALL_CUSTOMERS_FAILED, GET_ALL_CUSTOMERS_REQUEST } from '../action.type';
const intialState = {
  allCustomers: null,
  customersLoader: false
};

export const customerReducer = (state = intialState, action) => {
  switch (action.type) {
    case GET_ALL_CUSTOMERS_REQUEST:
      return {
        ...state,
        customersLoader: true,
        allCustomers: null,
      };
    case GET_ALL_CUSTOMERS:
      return {
        ...state,
        customersLoader: false,
        allCustomers: action.payload,
      };
    case GET_ALL_CUSTOMERS_FAILED:
      return {
        ...state,
        customersLoader: false,
        allCustomers: null,
      };
      
    default:
      return state;
  }
};
